export var ImpressionPixelType;
(function (ImpressionPixelType) {
    ImpressionPixelType["TMN_VIEW"] = "indeed-tmn-pxl";
    ImpressionPixelType["TMN_RENDER"] = "indeed-tmn-render";
    ImpressionPixelType["OFFCAP_RENDER"] = "indeed-offcap-render";
})(ImpressionPixelType || (ImpressionPixelType = {}));
